const templatesRoot = 'charge-export-templates';
export const chargeExportTemplateRoutes = {
  fields: "".concat(templatesRoot, "/fields"),
  list: templatesRoot,
  byId: templateId => "".concat(templatesRoot, "/").concat(templateId),
  setDefault: templateId => "".concat(templatesRoot, "/").concat(templateId, "/default")
};